<template>
  <section class="pb-12">
    <!-- preloader START -->
    <Preloader v-if="submitStatus == 'LOADING'" />
    <!-- preloader END -->
    <div>
      <p class="pb-4">
        Melde dich mit deiner bereits registrierten E-Mail-Adresse an und
        erhalte dein persönliches Änderungsformular per Mail.
      </p>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4">
        <!-- E-Mail START -->
        <div>
          <input
            class="w-full bg-white h-14 px-5 rounded focus:outline-none"
            :class="[
              submitStatus == 'ERROR' && !$v.edit.email.email ? 'error' : '',
              submitStatus == 'ERROR' && !$v.edit.email.required ? 'error' : '',
            ]"
            type="email"
            name="edit-email"
            placeholder="E-Mail Adresse*"
            v-model.trim="$v.edit.email.$model"
          />
          <div class="text-red-600 text-sm pt-2">
            <p v-if="submitStatus == 'ERROR' && !$v.edit.email.required">
              Erforderlich
            </p>
            <p v-if="submitStatus == 'ERROR' && !$v.edit.email.email">
              Eine gültige E-Mail-Adresse ist erforderlich.
            </p>
          </div>
        </div>
        <!-- E-Mail END -->
        <div class="flex justify-end md:justify-center">
          <button
            class="bg-mcdonalds-yellow rounded-full py-2 px-12 md:px-16 h-14 text-black text-xl speedee-bd focus:outline-none"
            @click="setTipiDataEdit()"
          >
            Absenden
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { scrollToIdMixin } from "../mixins";
import Preloader from "./Preloader";
import { required, email } from "vuelidate/lib/validators";
export default {
  components: {
    Preloader,
  },
  data() {
    return {
      submitStatus: null,
      edit: {
        email: "",
      },
    };
  },
  validations: {
    edit: {
      email: {
        required,
        email,
      },
    },
  },
  mixins: [scrollToIdMixin],
  methods: {
    // method to validate child components
    async setTipiDataEdit() {
      this.$v.$touch();
      let formData = new FormData();
      // create a json object from values to send to API
      let data = {
        email: this.edit.email,
      };

      formData.append("data", JSON.stringify(data));

      const settings = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "X-Requested-With": "XMLHttpRequest",
        },
      };
      // if validation is false
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "LOADING";
        this.axios
          .post(
            process.env.VUE_APP_WEBSERVICE_URL + "/?action=changetipi",
            formData,
            settings
          )
          .then(
            // get response if success
            async (dataRes) => {
              this.submitStatus = "OK";
              this.scrollToId();
              this.$swal({
                icon: "success",
                title: "Wir haben dir deinen Änderungslink zugeschickt.",
                showConfirmButton: false,
                html:
                  '<div class="my-8"><a href="https://www.mcdonalds.at/familyplus" class="bg-blue-600 rounded-md py-4 px-8 text-white text-2xl speedee-bd mt-4 swal2-confirm swal2-styled">OK</a></div>',
                allowOutsideClick: false,
              });
            }
            // catch the errors
          )
          .catch(function(error) {
            console.log(error);
          });
      }
    },
  },
};
</script>
